import { globalizeSelectors } from '../Utils';
import type { BusyAction, BusyState } from '../types/Busy';
/**
 * Just a simple flag to notify the UI that progress modal needs to be shown!
 */

/*
 * action types
 */

const types = {
  SET_BUSY: 'BUSY/SET_BUSY',
} as const;

/*
 * action creators
 */

const actions = {
  setBusy: (busy: boolean): BusyAction<boolean> => ({
    type: types.SET_BUSY,
    payload: busy,
  }),
};

const mountPath = 'busy'; // mount point in global state, must match root reducer

/**
 * Handling login and log out site actions
 */

const initialState: BusyState = {
  busy: false,
};

function reducer(
  state: BusyState = initialState,
  action: BusyAction
): BusyState {
  switch (action.type) {
    case types.SET_BUSY: {
      return { ...state, busy: action.payload as boolean };
    }
    default: {
      return state;
    }
  }
}

// selectors

const localSelectors = {
  busy: (state: BusyState): boolean => state.busy,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export { types as actionTypes, actions as default, selectors, reducer };
